(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var body = drawer.querySelector('[data-cart-body]');
  var footer = drawer.querySelector('[data-cart-footer]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var countInline = drawer.querySelector('[data-cart-count-inline]');
  var checkoutLink = drawer.querySelector('[data-checkout-link]');
  var warningEl = drawer.querySelector('[data-cart-warning]');
  var lastFocused = null;
  var currentItemCount = 0;
  var busy = false;   // a quantity/remove request is in flight
  var stale = false;  // the UI hasn't been confirmed against Shopify since the last change
  var requestId = 0;  // only the newest response is allowed to render
  var resync = false; // a refresh was asked for while a change was in flight
  var lastSig = null; // fingerprint of the last cart shown, shared with other tabs
  var renderedSig = null; // fingerprint of the rows currently in the drawer
  var pointerDown = false; // shopper is mid-press inside the drawer
  var pressedOutside = false; // the press that started this click began outside the drawer
  var pressedAction = null;   // the +/-/REMOVE the press landed on, captured before any re-render
  var deferredCart = null; // a refresh that arrived mid-press, applied right after the click
  var queue = [];          // clicks made while another change is still saving
  var latestCart = null;   // newest cart data received from Shopify

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Line item properties (e.g. "Processing: 2–7 business days"); "_" keys stay private.
  function propertiesHtml(item) {
    var props = item.properties || {};
    return Object.keys(props).filter(function (key) {
      return key.charAt(0) !== '_' && props[key] !== null && props[key] !== '';
    }).map(function (key) {
      return '<div class="revive-cart__item-variant" data-line-property>' + escapeHtml(key) + ': ' + escapeHtml(props[key]) + '</div>';
    }).join('');
  }

  function render(cart) {
    latestCart = cart;
    // Never rebuild the drawer while a button is being pressed; apply it right after the click.
    if (pointerDown) { deferredCart = cart; return; }
    var sig = cart.item_count + '|' + cart.items_subtotal_price + '|' +
      cart.items.map(function (item) { return item.key + 'x' + item.quantity; }).join(',');
    if (lastSig !== null && sig !== lastSig) tellOtherTabs(sig);
    lastSig = sig;
    stale = false;
    currentItemCount = cart.item_count;
    if (warningEl) warningEl.hidden = true;

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (countInline) countInline.textContent = cart.item_count;

    subtotalEl.textContent = money(cart.items_subtotal_price);
    // The footer's CSS sets display:flex, which overrides [hidden], so hide it inline too.
    footer.hidden = !cart.items.length;
    footer.style.display = cart.items.length ? '' : 'none';

    // Only rebuild the rows when the cart actually changed, so a background refresh
    // can't swap out a button while the shopper is clicking it.
    if (sig === renderedSig) return;
    renderedSig = sig;

    if (!cart.items.length) {
      body.innerHTML = '<div class="revive-cart__empty">YOUR CART IS EMPTY</div>';
      return;
    }

    body.innerHTML = cart.items.map(function (item, index) {
      return '' +
        '<div class="revive-cart__item" data-line="' + (index + 1) + '" data-key="' + escapeHtml(item.key) + '">' +
          '<div class="revive-cart__item-img"><img src="' + (item.image || '') + '" alt="' + item.product_title + '"></div>' +
          '<div class="revive-cart__item-info">' +
            '<div class="revive-cart__item-title">' + item.product_title + '</div>' +
            '<div class="revive-cart__item-variant">' + (item.variant_title || '') + '</div>' +
            propertiesHtml(item) +
            '<div class="revive-cart__item-row">' +
              '<div class="revive-cart__qty">' +
                '<button type="button" data-qty-dec aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-inc aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="revive-cart__item-price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="revive-cart__remove" data-remove aria-label="Remove ' + item.product_title + '">REMOVE</button>' +
        '</div>';
    }).join('');
  }

  function toJson(r) {
    if (!r.ok) throw new Error('Cart request failed: ' + r.status);
    return r.json();
  }

  function fetchCart() {
    if (busy) { resync = true; return Promise.resolve(); }
    var id = ++requestId;
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(toJson)
      .then(function (cart) { if (id === requestId) render(cart); return cart; })
      .catch(function (err) { console.error('[ReviveCart] could not load cart', err); });
  }

  // On the /cart page, re-render Dawn's cart sections from Shopify so the page matches the drawer.
  function swapContents(from, to) {
    if (!from || !to) return;
    to.className = from.className;
    to.innerHTML = from.innerHTML;
  }

  function syncCartPage() {
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var ids = [itemsEl, footerEl].filter(function (el) { return el && el.dataset.id; })
      .map(function (el) { return el.dataset.id; });
    if (!ids.length) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + ids.join(','), { cache: 'no-store' })
      .then(toJson)
      .then(function (sections) {
        ids.forEach(function (id) {
          if (!sections[id]) return;
          var doc = new DOMParser().parseFromString(sections[id], 'text/html');
          swapContents(doc.querySelector('cart-items'), document.querySelector('cart-items'));
          swapContents(doc.getElementById('main-cart-footer'), document.getElementById('main-cart-footer'));
        });
      })
      .catch(function () {});
  }

  function refreshAll() {
    fetchCart();
    syncCartPage();
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    stale = true;
    drawer.setAttribute('aria-busy', 'true');
    var id = ++requestId;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(toJson)
      .then(function (cart) { if (id === requestId) render(cart); })
      .catch(function (err) { console.error('[ReviveCart] cart change failed', err); })
      .then(function () {
        busy = false;
        drawer.removeAttribute('aria-busy');
        // Anything other than a clean render: re-read the real cart from Shopify.
        while (queue.length) { if (applyAction(queue.shift())) return; } // next queued click
        if (stale || resync) { resync = false; fetchCart(); }
        syncCartPage();
      });
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.setAttribute('data-open', ''); });
    document.documentElement.style.setProperty('overflow', 'hidden', 'important');
    document.body.style.setProperty('overflow', 'hidden', 'important');
    refreshAll();
    var closeBtn = drawer.querySelector('.revive-cart__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeDrawer() {
    document.documentElement.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden', 'revive-cart-open');
    document.documentElement.style.setProperty('overflow', 'visible', 'important');
    document.body.style.setProperty('overflow', 'visible', 'important');
    drawer.removeAttribute('data-open');
    setTimeout(function () { drawer.hidden = true; }, 300);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  var closeTriggers = drawer.querySelectorAll('[data-cart-close]');
  closeTriggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeDrawer();
    });
  });

  // What the shopper pressed on, read at pointerdown so a later re-render can't lose it.
  function actionFromTarget(target) {
    if (!target || !target.closest) return null;
    var item = target.closest('.revive-cart__item');
    if (!item || !body.contains(item)) return null;
    var key = item.getAttribute('data-key');
    if (target.closest('[data-qty-inc]')) return { key: key, kind: 'inc' };
    if (target.closest('[data-qty-dec]')) return { key: key, kind: 'dec' };
    if (target.closest('[data-remove]')) return { key: key, kind: 'remove' };
    return null;
  }

  function releasePointer() {
    if (!pointerDown) return;
    pointerDown = false;
    // Runs after the click handler, so the click always lands on the row the shopper pressed.
    setTimeout(function () {
      var cart = deferredCart;
      deferredCart = null;
      if (cart && !busy) render(cart);
    }, 0);
  }
  document.addEventListener('pointerdown', function (e) {
    pressedOutside = !panelEl.contains(e.target) && !e.target.closest('[data-cart-open]');
    if (pressedOutside) return;
    pointerDown = true;
    pressedAction = actionFromTarget(e.target);
  }, true);
  // Act on release, not on 'click': if a refresh replaced the row between press and release,
  // the browser never fires a click at all, and the shopper's tap would be lost.
  document.addEventListener('pointerup', function (e) {
    var action = pressedAction;
    pressedAction = null;
    if (action && panelEl.contains(e.target)) requestChange(action);
    releasePointer();
  }, true);
  document.addEventListener('pointercancel', function () {
    pressedAction = null;
    releasePointer();
  }, true);

  // Apply one +, − or REMOVE click to the item's newest known quantity (found by line item key).
  function applyAction(action) {
    var items = (latestCart && latestCart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].key !== action.key) continue;
      var qty = items[i].quantity;
      var next = action.kind === 'inc' ? qty + 1 : action.kind === 'dec' ? Math.max(0, qty - 1) : 0;
      changeLine(action.key, next);
      return true;
    }
    return false; // item no longer in the cart
  }

  function requestChange(action) {
    if (busy) { if (queue.length < 10) queue.push(action); return; } // apply after the current save
    applyAction(action);
  }

  // Keyboard activation (Enter/Space on a button) fires a click with no pointer behind it.
  body.addEventListener('click', function (e) {
    if (e.detail !== 0) return; // pointer clicks are handled on release, above
    var action = actionFromTarget(e.target);
    if (action) requestChange(action);
  });

  if (checkoutLink) {
    checkoutLink.addEventListener('click', function (e) {
      if (busy) { e.preventDefault(); return; }
      if (!stale && currentItemCount > 0) return; // cart is confirmed and has items: go to checkout
      // Never block checkout on what the drawer last showed: ask Shopify for the real cart first.
      e.preventDefault();
      var href = checkoutLink.href;
      fetchCart().then(function (cart) {
        if (cart && cart.item_count > 0) window.location.href = href;
        else if (cart && warningEl) warningEl.hidden = false;
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  document.addEventListener('revive:cart:updated', fetchCart);
  // Keep the badge/drawer in sync when Dawn code (e.g. the /cart page) changes the cart.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { fetchCart(); });
  }

  // Another tab may have changed the cart: re-read it when this tab becomes active again.
  var lastReturnRefresh = 0;
  function refreshOnReturn() {
    if (document.visibilityState === 'hidden') return;
    if (Date.now() - lastReturnRefresh < 1000) return;
    lastReturnRefresh = Date.now();
    refreshAll();
  }
  window.addEventListener('focus', refreshOnReturn);

  // When this tab changes the cart, tell the store's other open tabs to refresh right away.
  var channel = null;
  try { channel = new BroadcastChannel('revive-cart'); } catch (err) {}
  function onOtherTabChange(sig) {
    if (!sig || sig === lastSig) return;
    lastSig = sig;
    refreshAll();
  }
  function tellOtherTabs(sig) {
    try { if (channel) channel.postMessage(sig); else localStorage.setItem('revive-cart-sig', sig); } catch (err) {}
  }
  if (channel) channel.onmessage = function (e) { onOtherTabChange(e.data); };
  else window.addEventListener('storage', function (e) { if (e.key === 'revive-cart-sig') onOtherTabChange(e.newValue); });
  document.addEventListener('visibilitychange', refreshOnReturn);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshOnReturn(); });

  window.ReviveCart = { open: openDrawer, close: closeDrawer, refresh: fetchCart };

  var panelEl = drawer.querySelector('.revive-cart__panel');
  document.addEventListener('click', function (e) {
    if (drawer.hidden) return;
    // Close only when the press that produced this click began outside the drawer. A rebuild
    // mid-click can retarget the click to <body>, which must never close the drawer.
    if (!pressedOutside) return;
    if (panelEl.contains(e.target)) return;
    if (e.target.closest('[data-cart-open]')) return;
    closeDrawer();
  }, true);

  fetchCart();
})();